import { useEffect, useState } from "react";

/**
 * Hook to detect if the device supports hover interactions
 * Uses media queries to detect devices with fine pointer and hover capability
 * @returns {boolean} true if hover is supported, false otherwise
 */
const useHoverSupport = () => {
  const [isHoverSupported, setIsHoverSupported] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const hoverQuery =
      typeof window.matchMedia === "function"
        ? window.matchMedia("(hover: hover) and (pointer: fine)")
        : null;

    const evaluateSupport = () => {
      const pointerCapable = hoverQuery ? hoverQuery.matches : true;
      setIsHoverSupported(pointerCapable);
    };

    evaluateSupport();

    const handleHoverChange = () => evaluateSupport();

    if (hoverQuery) {
      if (hoverQuery.addEventListener) {
        hoverQuery.addEventListener("change", handleHoverChange);
      } else if (hoverQuery.addListener) {
        // Fallback for older browsers
        hoverQuery.addListener(handleHoverChange);
      }
    }

    return () => {
      if (hoverQuery) {
        if (hoverQuery.removeEventListener) {
          hoverQuery.removeEventListener("change", handleHoverChange);
        } else if (hoverQuery.removeListener) {
          // Fallback for older browsers
          hoverQuery.removeListener(handleHoverChange);
        }
      }
    };
  }, []);

  return isHoverSupported;
};

export default useHoverSupport;

